import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { WorkingGroup } from '../models/working-group';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WorkingGroupService {

  private apiUrl = `${environment.apiUrl}/working-groups`;

  constructor(private http: HttpClient) {}

  getByYear(year: string): Observable<WorkingGroup[]> {
    return this.http.get<WorkingGroup[]>(`${this.apiUrl}/year/${year}`);
  }

  create(group: WorkingGroup): Observable<WorkingGroup> {
    return this.http.post<WorkingGroup>(this.apiUrl, group);
  }

  update(id: number, group: WorkingGroup): Observable<WorkingGroup> {
    return this.http.put<WorkingGroup>(`${this.apiUrl}/${id}`, group);
  }

  delete(id: number, targetGroupId?: number): Observable<void> {
    const params = targetGroupId != null
      ? new HttpParams().set('targetGroupId', String(targetGroupId))
      : undefined;
    return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
  }
  updatePeriod(id: number, period: any): Observable<any> {
    return this.http.put(`${environment.apiUrl}/working-periods/${id}`, period);
  }

  deletePeriod(id: number): Observable<any> {
    return this.http.delete(`${environment.apiUrl}/working-periods/${id}`);
  }

}
